import React from 'react'

import FoodMenus from '../SingleComponents/MenuSection3'

export default function Menu() {
  return (
    <div>
        <FoodMenus></FoodMenus>
    </div>
  )
}
